export default "__VITE_ASSET__DNkpAvR8__"